<ng-container *ngFor="let question of questionnaire.questions">
  <p
    class="gpb-8 gmb-0"
    [class.h4-bold]="!smallTitle"
    [class.h7-bold]="smallTitle"
  >
    {{ question.name }}
  </p>

  <ng-container *ngIf="question.answers.length > 1">
    <ng-container
      *ngTemplateOutlet="options; context: { question: question }"
    ></ng-container>
  </ng-container>
  <ng-container *ngIf="question.answers.length === 1">
    <ng-container
      *ngTemplateOutlet="slider; context: { question: question }"
    ></ng-container>
  </ng-container>
</ng-container>

<ng-template #slider let-question="question">
  <div class="gmt-12 gmb-24">
    <app-slider
      [min]="question.answers[0].min"
      [max]="question.answers[0].max"
      [control]="form.get(question.id)"
      [sliderData]="{
        title: 'ANALYSES.SINGLE.DAYS_PER_WEEK',
      }"
      (valueChanged)="track(question.id, question.answers[0].id)"
    ></app-slider>

    <small
      *ngIf="form.get(question.id).touched && form.get(question.id).errors?.min"
      class="form-text text-danger gpt-8 gpl-16"
    >
      {{ 'MIN_VALUE' | translate }}
    </small>
  </div>
</ng-template>

<ng-template #options let-question="question">
  <gpu-radio-group
    [formControlName]="question.id"
    (ngModelChange)="track(question.id)"
  >
    <gpu-radio-button
      *ngFor="let answer of question.answers; let i = index"
      id="option_{{ question.id }}_{{ i }}_{{ answer.id }}"
      name="value{{ i }}"
      class="gmt-12 gmb-24 d-block"
      [value]="answer.id"
    >
      {{ answer.name }}
    </gpu-radio-button>
  </gpu-radio-group>
</ng-template>
